function updatePanelSpacing() {
    const visible = [...document.querySelectorAll('.faq-panel')].filter((p) => p.classList.contains('active'));
    visible.forEach((p, i) => {
      p.classList.toggle('panel-not-first', i !== 0);
    });
  }

  function toggleFaq(qEl) {
    const item = qEl.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    item
      .closest('.faq-list')
      .querySelectorAll('.faq-item.open')
      .forEach((i) => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  }
function filterFaqs(query) {
    const raw = $.trim(query).toLowerCase();
    const $noMatch = $('#noMatch');
    const $navWrap = $('#faqNavWrap');
    const $items = $('.faq-item');
    if (!raw) {
        $items.each(function () {
            $(this).show();
            const $q = $(this).find('.faq-q-text');
            const $a = $(this).find('.faq-a-inner');
            $q.html($q.text());
            $a.html($a.text());
        });
        $noMatch.removeClass('visible');
        $navWrap.css({ opacity: '1', pointerEvents: '' });
        return;
    }
    $('.faq-panel').addClass('active').show();
    $navWrap.css({ opacity: '.4', pointerEvents: 'none' });
    const words = raw.split(/\s+/).filter(Boolean);
    let anyVisible = false;
    $items.each(function () {
        const $item = $(this);
        const text = $item.text().toLowerCase();
        let match = words.every(word => text.includes(word));
        if (match) {
            $item.show();
            anyVisible = true;
            // Highlight match (optional)
            const regex = new RegExp(`(${words.join('|')})`, 'gi');
            $item.find('.faq-q-text').html(function (_, html) {
                return html.replace(regex, '<mark>$1</mark>');
            });
            $item.find('.faq-a-inner').html(function (_, html) {
                return html.replace(regex, '<mark>$1</mark>');
            });
        } else {
            $item.hide();
        }
    });

    $noMatch.toggleClass('visible', !anyVisible);

    updatePanelSpacing();
}
  function toggleSearch() {
    const wrap = document.getElementById('navSearchWrap');
    wrap.classList.toggle('open');
    if (wrap.classList.contains('open')) document.getElementById('navSearchInput').focus();
  }
  document.addEventListener('click', (e) => {
    const wrap = document.getElementById('navSearchWrap');
    if (wrap && !wrap.contains(e.target)) wrap.classList.remove('open');
  });

  const ios = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('vis');
          ios.unobserve(e.target);
        }
      });
    },
    { threshold: 0.08 }
  );
  document.querySelectorAll('.reveal').forEach((el) => ios.observe(el));

$('.faq-list .faq-panel').click(function () {
    const $panel = $(this);
    const $item = $panel.find('.faq-item');
    $panel.toggleClass('reveal vis');
    $item.toggleClass('open');
});
$(document).on("click",".faq-nav-inner .faq-nav-tab",function() {
    $(this).addClass('active').siblings().removeClass('active');
    const filter = $(this).data('match');
    if (filter === 'all') {
        $('.Main_faq').show();
    } else {
        $('.Main_faq').hide().filter(`[data-match="${filter}"]`).show();
    }
});

$(document).ready(function () {
    $('.faq-nav-tab').first().trigger('click');
});